import React from 'react';
import './Projects.css';

const projectsData = [
  {
    id: 1,
    title: 'MemoBridge',
    category: 'web-app',
    description:
      'Smart Memory Assistance for Alzheimer’s Patients, MemoBridge is a smart healthcare assistant that helps Alzheimer’s patients recall people, events, and memories, strengthening connections with caregivers effectively.',
    techStack: ['React', 'Flask', 'SQLite'],
    github: 'https://github.com/rabinpandey123/MemoBridge',
  },
  {
    id: 2,
    title: 'Emotion Recognition System',
    category: 'web-app',
    description:
      'This project implements Facial Emotion Recognition (FER) to detect human emotions from images or video streams. The system uses a pretrained model with the FER library and Deepface to classify facial expressions',
    techStack: ['Python Flask', 'React', "OpenCV",'DeepFace', "FER"],
    github: 'https://github.com/rabinpandey123/Emotion_Recognition_system',
  },
  {
    id: 3,
    title: 'Face Detection System',
    category: 'web-app',
    description:
      'This project is a simple Face Detection Application built using Python, [MTCNN], and [OpenCV]. It can detect faces in images or from a live webcam stream and highlight facial landmarks (eyes, nose, and mouth) for each detected face.',
    techStack: ['Python', 'OpenCV', 'MTCNN'],
    liveDemo: null, // no live demo for this one
    github: 'https://github.com/rabinpandey123/Face_Detection_system',
  },

    {
    id: 4,
    title: 'Second-Hand Marketing System',
    category: 'web-app',
    description:
      ' Second-Hand Marketing is a full-stack web application that allows users to buy and sell second-hand products in a user-friendly and secure environment.',
    techStack: ['HTML/CSS/JS', 'Java SpringBoot', 'MySQL'],
    liveDemo: null, // no live demo for this one
    github: 'https://github.com/rabinpandey123/second_hand_marketing_system',
  },

];

const Projects = () => {
  return (
    <section className="projects-section">
      <div className="projects-header">
        <h2>Featured Projects</h2>
        <p>Some of my best work</p>
      </div>
      <div className="projects-grid">
        {projectsData.map((project) => (
          <div className="project-card" key={project.id}>
            <div className="project-card-header">
              <h3 className="project-title">{project.title}</h3>
              <span className="project-category">{project.category}</span>
            </div>
            <p className="project-description">{project.description}</p>
            <div className="tech-stack">
              {project.techStack.map((tech, idx) => (
                <span key={idx} className="tech-tag">{tech}</span>
              ))}
              {/* optional: show +2 if more than displayed, but here we show all */}
            </div>
            <div className="project-links">
              {project.liveDemo && (
                <a href={project.liveDemo} target="_blank" rel="noopener noreferrer" className="link-btn">
                  Live Demo
                </a>
              )}
              <a href={project.github} target="_blank" rel="noopener noreferrer" className="link-btn">
                GitHub
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;